import * as angular from "angular";

angular
  .module('bringoz.admin.deliveries')
  .constant('Deliveries_PN', {
    database: 'services',
    isBranchEntity: true
  });
